import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectUrl } from './DataObjectUrl';
import { DataObjectRelationsTableDto } from '../types';
import { DataObjectRelationsTableDtoSchema } from '../schema/DataObjectRelationsTableDtoSchema';

const getDataObjectRelationsTable = (filters: any) =>
  apiClient
    .get<DataObjectRelationsTableDto>(
      expand(DataObjectUrl.RELATIONS_TABLE, filters),
    )
    .then((response) => DataObjectRelationsTableDtoSchema.parse(response.data));

export const useGetDataObjectRelationsTable = createApiQueryHook(
  ['data-object-relations-table'],
  getDataObjectRelationsTable,
);
